require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-ian-pooley.json") })
        }
      }, "path---interview-ian-pooley");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-ian-pooley!./.cache/json/interview-ian-pooley.json
// module id = 680
// module chunks = 231608221292675